import { ComponentType, JSX } from 'react';

import { CloseDialogContext } from '../context';
import { DialogBase } from './DialogBase';
import { CloseDialogFn } from '../types';

type DialogWrapperProps<PROPS, RESULT> = {
  DialogComponent: ComponentType<PROPS>;
  dialogComponentProps: PROPS;
  closeOnOverlayClick?: boolean;
  destroy: CloseDialogFn<RESULT>;
};

export const DialogWrapper = <PROPS, RESULT>({
  DialogComponent,
  dialogComponentProps,
  closeOnOverlayClick,
  destroy,
}: DialogWrapperProps<PROPS, RESULT>) => {
  return (
    <CloseDialogContext value={destroy as CloseDialogFn<unknown>}>
      <DialogBase closeOnOverlayClick={closeOnOverlayClick}>
        <DialogComponent
          {...(dialogComponentProps as PROPS & JSX.IntrinsicAttributes)}
        />
      </DialogBase>
    </CloseDialogContext>
  );
};
